import type { TFootnoteEntryElement } from '@alpod-ai-writer/plate-plugins/footnotes';
import { FootnoteEntryPlugin } from '@alpod-ai-writer/plate-plugins/footnotes/react';
import { cn, withRef } from '@udecode/cn';
import { PlateElement, useEditorPlugin, usePluginOption } from '@udecode/plate/react';
import { useCallback } from 'react';

export const FootnoteEntryElement = withRef<typeof PlateElement, {}>(({
    children,
    className,
    ...props
}, ref) => {
    const footnotesOffset = usePluginOption(FootnoteEntryPlugin, 'footnoteIndexOffset');
    const element = props.element as TFootnoteEntryElement;
    const plugin = useEditorPlugin(FootnoteEntryPlugin);

    const handleOnClick = useCallback(() => {
        if (element.id) {
            plugin.api.footnoteEntry.select(element.id);
        }
    }, [ element, plugin ]);

    const index = String(footnotesOffset + element.index + 1);

    return (
        <PlateElement
            as={'div'}
            ref={ref}
            className={cn(
                'flex flex-row items-start px-1.5 py-0.5 rounded-md bg-transparent hover:bg-blue-100 cursor-pointer transition-all duration-200',
                className
            )}
            data-slate-value={element.ref}
            onClick={handleOnClick}
            {...props}
        >
            <span className='inline-block text-xs align-super leading-4 mr-1'>{index}</span>
            <div className='grow text-sm break-all'>
                {children}
            </div>
        </PlateElement>
    );
});
